import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { Button, Container, Dropdown, Form, Image, Nav, Navbar, Spinner } from '@themesberg/react-bootstrap';
import Profile3 from "../assets/img/team/profile-picture-10.png";
import { Routes } from "../routes";
import { connect, useDispatch, useSelector } from "react-redux";
import { profileAction } from "../actions/user";
import { logout } from "../actions/auth";
import DatePicker from "react-datepicker";
import { setDashboardDate, getDashboardData } from "../actions/app";
import { getSeptemberFirst2025, dateNow } from "../helpers/dateHelper";
import { action } from "../actions";
import { DASHBOARD_DATE } from "../actions/types";

export const NavBar = ({ component: Component, ...rest }) => {
    // const history = useHistory();
    const [username, setUsername] = useState("");
    const [startDate, setStartDate] = useState((getSeptemberFirst2025().getTime()));
    const [endDate, setEndDate] = useState((dateNow().getTime()));
    const dispatch = useDispatch();
    const { dates, loadingState } = useSelector((store) => store.app);

    const onChangeDates = () => {
        dispatch(action(DASHBOARD_DATE, {
            from: startDate,
            to: endDate,
        }));
        // Trigger dashboard data fetch with selected dates
        dispatch(getDashboardData({ from: startDate, to: endDate }));
    }

    const logout = async () => {
        const { logout } = rest;
        await logout();
        window.location = Routes.Login.path;
    }
    //
    const setDates = (date, r = 'f') => {
        switch (r) {
            case 'f':
                setStartDate(() => date)
                break;
            case 't':
                setEndDate(() => date)
                break;
        }
        onChangeDates();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    let mounted = useRef().current;
    useEffect(() => {
        const username = rest.user ? rest.user.name + " " : "";
        setUsername(username);
        if (!mounted && dates === undefined) {
            dispatch(action(DASHBOARD_DATE, {
                from: startDate,
                to: endDate,
            }));
            mounted = true;
        }
    }, [mounted, startDate, endDate, dates]);

    return (
        <Navbar variant="dark" expanded className="ps-0 pe-2 pb-0">
            <Container fluid className="px-0">
                <div className="d-flex justify-content-between w-100">
                    <div className="d-flex align-items-center">
                        <Form className="d-inline-flex align-items-center">
                            {
                                (rest.currentPage === Routes.DashboardOverview.path) ? (
                                    <>
                                        <Form.Group className={'me-4'} controlId="formStartDate">
                                            <DatePicker
                                                selected={startDate}
                                                className={'form-control'}
                                                name={'_s'}
                                                onChange={(date) => {
                                                    setDates(date.getTime())
                                                }} />
                                        </Form.Group>
                                        <Form.Group className={'me-4'} controlId="formEndDate">
                                            <DatePicker
                                                className={'form-control'}
                                                name={'_e'}
                                                selected={endDate}
                                                onChange={(date) => {
                                                    setDates(date.getTime(), 't')
                                                }} />
                                        </Form.Group>
                                        <Button variant="primary" type="button" onClick={onChangeDates} disabled={loadingState}>
                                            {loadingState ? (
                                                <>
                                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                                                    Loading...
                                                </>
                                            ) : (
                                                'Search'
                                            )}
                                        </Button>
                                    </>
                                ) : (<></>)
                            }
                        </Form>
                    </div>
                    <Nav className="align-items-center">
                        <Dropdown as={Nav.Item}>
                            <Dropdown.Toggle as={Nav.Link} className="pt-1 px-0">
                                <div className="media d-flex align-items-center">
                                    <Image src={Profile3} className="user-avatar md-avatar rounded-circle" />
                                    <div className="media-body ms-2 text-dark align-items-center d-none d-lg-block">
                                        <span className="mb-0 font-small fw-bold">{username}</span>
                                    </div>
                                </div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="user-dropdown dropdown-menu-right mt-2">
                                {/*<Dropdown.Item className="fw-bold">*/}
                                {/*    <FontAwesomeIcon icon={faUserCircle} className="me-2"/> My Profile*/}
                                {/*</Dropdown.Item>*/}
                                {/*<Dropdown.Divider/>*/}
                                <Dropdown.Item className="fw-bold" onClick={logout}>
                                    <FontAwesomeIcon icon={faSignOutAlt} className="text-danger me-2" /> Logout
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Nav>
                </div>
            </Container>
        </Navbar>
    );
};

const mapStateToProps = (state) => {
    const { isLoggedIn } = state.authentication;
    const { user, error } = state.profile;
    const { currentPage, loadingState, dates, dashboard } = state.app;
    return {
        isLoggedIn, user, error, currentPage, loadingState, dates,
        dashboard,
    };
}

export default connect(mapStateToProps, {
    profileAction,
    logout,
    setDashboardDate,
})(NavBar);
